import { Plus, Trash2 } from "lucide-react";

import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";

import {
  CommonProps,
  type PropsEditorProps,
  Section,
} from "./common";

export function SelectProps(props: PropsEditorProps): JSX.Element {
  const { field, onUpdate } = props;
  const options = field.options ?? [];

  const updateOption = (idx: number, key: "value" | "label", val: string) => {
    const next = options.map((o, i) => (i === idx ? { ...o, [key]: val } : o));
    onUpdate({ options: next });
  };

  const removeOption = (idx: number) => {
    onUpdate({ options: options.filter((_, i) => i !== idx) });
  };

  const addOption = () => {
    const nextVal = `option_${options.length + 1}`;
    onUpdate({
      options: [...options, { value: nextVal, label: `Lựa chọn ${options.length + 1}` }],
    });
  };

  return (
    <>
      <CommonProps {...props} />
      <Section title="Options">
        {options.map((opt, idx) => (
          <div key={idx} className="flex items-center gap-1">
            <Input
              value={String(opt.value)}
              onChange={(e) => updateOption(idx, "value", e.target.value)}
              placeholder="value"
              className="h-8 text-xs flex-1"
            />
            <Input
              value={opt.label}
              onChange={(e) => updateOption(idx, "label", e.target.value)}
              placeholder="Label"
              className="h-8 text-xs flex-1"
            />
            <Button
              size="icon"
              variant="ghost"
              className="size-7 shrink-0"
              onClick={() => removeOption(idx)}
            >
              <Trash2 className="size-3.5" />
            </Button>
          </div>
        ))}
        <Button size="sm" variant="outline" onClick={addOption} className="w-full">
          <Plus className="size-3.5 mr-1" /> Thêm option
        </Button>
      </Section>
    </>
  );
}
